import React, { TextareaHTMLAttributes } from "react";

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
  required?: boolean;
  resizable?: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({
  label,
  error,
  required = false,
  id,
  rows = 4,
  resizable = true,
  ...rest
}) => {
  return (
    <div>
      <label
        htmlFor={id}
        className="block text-[#1E1E1E] text-[14px] font-[500] mb-1"
      >
        {label}
        {required && <span className="text-[#DC2626]">*</span>}
      </label>
      <div className="mb-[16px]">
        <textarea
          id={id}
          rows={rows}
          className={`w-full px-3 py-2 border ${
            error ? "border-[#FF3B30]" : "border-[#E0E0E0]"
          } rounded-[6px] text-[14px] font-[400] focus:outline-none focus:border-[#73B5C5] placeholder:text-[#B3B3B3] ${
            resizable ? "resize-vertical" : "resize-none"
          }`}
          {...rest}
        />
        {error && (
          <p className="mt-0 text-[12px] font-[500] text-[#FF3B30]">{error}</p>
        )}
      </div>
    </div>
  );
};

export default TextArea;
